import React, { forwardRef, useCallback, useImperativeHandle, useMemo, useState } from 'react';
import { SelectMultiple, LoadingTip } from 'tea-component';

import appStore from '@/pages/intelligence/assets/svg/dataSource/appstore.svg';
import googleplay from '@/pages/intelligence/assets/svg/dataSource/googleplay.svg';
import steam from '@/pages/intelligence/assets/svg/dataSource/steam.svg';
import taptap from '@/pages/intelligence/assets/svg/dataSource/taptap.svg';
import twitch from '@/pages/intelligence/assets/svg/dataSource/twitch.svg';
import youtube from '@/pages/intelligence/assets/svg/dataSource/youtube.svg';
import facebook from '@/pages/intelligence/assets/svg/dataSource/facebook.svg';
import fbGaming from '@/pages/intelligence/assets/svg/dataSource/fbgaming-bg.svg';
import discord from '@/pages/intelligence/assets/svg/dataSource/discord.svg';
import xiaomi from '@/pages/intelligence/assets/svg/dataSource/xiaomi.svg';
import Instagram from '@/pages/intelligence/assets/svg/dataSource/instagram.svg';
import Metacritic from '@/pages/intelligence/assets/svg/dataSource/metacritic.svg';
import Cafe from '@/pages/intelligence/assets/svg/dataSource/cafe.svg';
import Opencritic from '@/pages/intelligence/assets/svg/dataSource/opencritic.svg';
import Reddit from '@/pages/intelligence/assets/svg/dataSource/reddit.svg';
import Ruliweb from '@/pages/intelligence/assets/svg/dataSource/ruliweb.svg';
import Tiktok from '@/pages/intelligence/assets/svg/dataSource/tiktok.svg';
import Twitter from '@/pages/intelligence/assets/svg/dataSource/twitter.svg';
import VK from '@/pages/intelligence/assets/svg/dataSource/vk.svg';
import YouTubeG from '@/pages/intelligence/assets/svg/dataSource/youtubegaming.svg';

import { renderImgText } from '../TeaSelector/MultipleSelector';
import useDebounce from '@intelligence/components/GenreSelectMiddleware/Supports/_hooks/useDebounce';
import { useIntl } from 'umi';

const OpinionDataSourceAll = (props, ref: React.Ref<any>): React.ReactElement => {
  const {
    onConfirm,
  } = props;

  // console.log(props)
  const { formatMessage } = useIntl();

  const dataSourceAll = [
    {
      text: 'App Store',
      value: 'App Store',
      img: appStore,
    },
    {
      text: 'Discord',
      value: 'Discord',
      img: discord,
    },
    {
      text: 'Facebook',
      value: 'Facebook',
      img: facebook,
    },
    {
      text: 'Facebook Gaming',
      value: 'Facebook Gaming',
      img: fbGaming,
    },
    {
      text: 'Google Play',
      value: 'Google Play',
      img: googleplay,
    },
    {
      text: 'Instagram',
      value: 'Instagram',
      img: Instagram,
    },
    {
      text: 'Metacritic',
      value: 'Metacritic',
      img: Metacritic,
    },
    {
      text: 'Naver Cafe',
      value: 'Naver Cafe',
      img: Cafe,
    },
    {
      text: 'Opencritic',
      value: 'Opencritic',
      img: Opencritic,
    },
    {
      text: 'Reddit',
      value: 'Reddit',
      img: Reddit,
    },
    {
      text: 'Ruliweb',
      value: 'Ruliweb',
      img: Ruliweb,
    },
    {
      text: 'Steam',
      value: 'Steam',
      img: steam,
    },
    {
      text: 'Tiktok',
      value: 'Tiktok',
      img: Tiktok,
    },
    {
      text: 'Twitch',
      value: 'Twitch',
      img: twitch,
    },
    {
      text: 'Twitter',
      value: 'Twitter',
      img: Twitter,
    },
    {
      text: 'VK',
      value: 'VK',
      img: VK,
    },
    {
      text: 'YouTube',
      value: 'YouTube',
      img: youtube,
    },
    {
      text: 'YouTube Gaming',
      value: 'YouTube Gaming',
      img: YouTubeG,
    },
    {
      text: 'Oppo Store',
      value: 'Oppo Store',
      img: youtube,
    },
    {
      text: 'Taptap io',
      value: 'Taptap io',
      img: taptap,
    },
    {
      text: 'Xiaomi Market',
      value: 'Xiaomi Market',
      img: xiaomi,
    },
  ]


  // 搜索关键字
  const [keywords, setKeywords] = useState('');
  // 已选择公司列表数据(不区分非搜索模式、搜索模式)
  const [selected, setSelected] = useState(dataSourceAll.map((item)=>{return item?.value}))

  const [searchList, setSearchList] = useState<string[]>([]);

  const [isAll, setIsAll] = useState(true)

  const renderOptions = () => {
    return dataSourceAll?.map((item, idx) => ({
      value: item?.value,
      text: (renderImgText(item?.text, item?.img)
      ),
      buttonText: renderImgText(item?.text, item?.img),
    }));
  };

  const handleChange = useCallback((value: string[]) => {
    // console.log("CHANGE")
    let payload = value;

    setSelected(value);

    if (!keywords) {
      payload = !value?.length || value?.length === dataSourceAll?.length ? [] : value;
    }

    if (keywords) {
      let isAll = true;

      searchList?.forEach((item) => {
        if (!value?.includes(item)) {
          isAll = false;
          // console.log("FALSE", item)
        }
      })

      setIsAll(isAll)
    } else {
      if (value?.length === dataSourceAll?.length) {
        setIsAll(true);
      } else {
        setIsAll(false)
      }
    }

    onConfirm instanceof Function && onConfirm(payload);

    // console.log(payload)
  }, [keywords, onConfirm]);

  // console.log("SEARCHLIST", searchList)

  const buttonLabel = useMemo(() => {
    const selectedCount = selected?.length || 0;
    const dataSourceCount = dataSourceAll?.length || 0;
    let result = '';
    if (!selectedCount || selectedCount === dataSourceCount) { // 没选择公司 或者 全选公司(包含 非搜索状态 和 搜索状态)
      result = formatMessage({ id: 'dbi_all' });
    } else if (selectedCount < 3) { // 选择公司数量小于3个
      result = selected.join(', ');
    } else { // 选择公司数量 大于 3 且 小于 全部公司(区分 非搜索状态 和 搜索状态)
      result = String(selectedCount);
    }
    return result
  }, [selected]);

  const handleReset = useCallback(() => {
    setKeywords('');
    setSelected(dataSourceAll.map((item)=>{return item?.value}))
    onConfirm instanceof Function && onConfirm([]);
  }, [onConfirm]);


  useImperativeHandle(ref, () => ({
    reset: handleReset,
  }));


  const onSelectAll = () => {
    const values = dataSourceAll?.map((item) => {
      return item?.value
    })

    if (!keywords) {
      if (isAll) {
        setSelected([])
        setIsAll(false)
      } else {
        setSelected(values)
        setIsAll(true)
      }

      return
    }

    if (isAll) {
      // 删除元素
      const newSelected = selected.filter((item) => {return !(searchList?.includes(item))})

      // console.log(newSelected)

      setSelected(newSelected)
      setIsAll(false)
    } else {
      // 添加元素
      const newSelected = Array.from(new Set([...selected, ...searchList]))

      // console.log(newSelected)

      setSelected(newSelected)
      setIsAll(true)
    }
  }

  const searchDebounce = useDebounce(async (...args: [string, number, boolean]) => {
    const keywords = args[0];
    if (!keywords) {
      if (selected.length === 0) {
        setSelected(dataSourceAll.map((item)=>{return item?.value}));
      }
      setSearchList([])
      return;
    }
    const res = dataSourceAll?.filter((item) => {return item?.value?.toUpperCase()?.includes(keywords?.toUpperCase())})?.map((item) => {return item?.value})

    setSearchList(res)

    let isAll = true;

    res?.forEach((item) => {
      if (!selected?.includes(item)) {
        isAll = false;
      }
    })

    setIsAll(isAll)
  }, 600);

  const handleSearch = useCallback((keywords?: string) => {
    const _keywords = keywords || '';
    setKeywords(_keywords);
    searchDebounce(_keywords, 1, false);
  }, [searchDebounce]);

  const handleClose = useCallback(() => {
    let payload = selected;
    if (!selected?.length) {
      setSelected(dataSourceAll.map((item)=>{return item?.value}));
      payload = dataSourceAll.map((item)=>{return item?.value});
    }
    if (!keywords) {
      payload = !payload?.length || payload?.length === dataSourceAll?.length ? [] : payload;
    }
    onConfirm instanceof Function && onConfirm(payload);
  }, [keywords, selected, onConfirm])

  return (
    <>
      <SelectMultiple
        className={'select-item'}
        style={{width: '270px'}}
        staging={false}
        searchValue={keywords}
        searchable
        listHeight={254}
        appearance="button"
        options={renderOptions()}
        onSearchValueChange={(keyword) => {
          setKeywords(keyword);
        }}
        onChange={handleChange}
        onSearch={handleSearch}
        onClose={handleClose}
        value={selected}
        button={
          <div className="dbi-select-button">
            <div className="select-button-text">{formatMessage({ id: 'dbi-sm-filter-datasource' })}</div>
            <div className="select-button-desc">
              {buttonLabel}
            </div>
          </div>
        }
        tips={
          <div className="dbi-selects-flex">
            <span className="dbi-selects-flex-lf">{formatMessage({ id: 'dbi-sm-filter-datasource' })}</span>
            <span className="dbi-selects-flex-rt"
              onClick={onSelectAll}
            >
              {!isAll ? 'Select All' : 'Clear All'}
            </span>
          </div>
        }
        matchButtonWidth
      />
    </>
  );
}

export default forwardRef(OpinionDataSourceAll);
